var summernote_editor = function() {
  $('[data-provider="summernote"]').each(function() {
    $(this).summernote({
      height: 150,
      toolbar: [
        ['font_style', ['bold', 'italic', 'underline', 'clear']]
      ]
    });
  });

  $('[data-provider="summernote-large"]').each(function() {
    $(this).summernote({
      height: 200,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['height', ['height']]
      ]
    });
  });
};

$(document).on('ready', summernote_editor);
$(document).on('page:load', summernote_editor);
